import { useCopyToClipboard } from 'react-use';

import { type Board } from '@air/api/types';
import { Check } from '@air/next-icons';
import { Tooltip } from '@air/primitive-tooltip';
import { useAirModal } from '@air/provider-modal';

import { DemoFormModal } from '~/components/Modals/DemoFormModal';
import { useIsApiAdmin } from '~/hooks/useIsApiAdmin';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { canManageSubscription } from '~/utils/permissions/workspacePermissions';

export type BoardIdProps = Required<Pick<Board, 'id'>>;

export const BoardId = ({ id }: BoardIdProps) => {
  const { isApiAdmin } = useIsApiAdmin();
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();
  const [showContactSalesModal] = useAirModal(DemoFormModal);
  const [state, copyToClipboard] = useCopyToClipboard();

  const canEditPlan = canManageSubscription(workspacePermissions);

  return (
    <div className="flex flex-col items-start gap-1">
      <div className="font-medium text-12 text-grey-10">Board ID</div>

      <div className="flex gap-1">
        {isApiAdmin ? (
          <>
            <Tooltip label="Copy to clipboard">
              <button className="select-all text-12 text-grey-9" onClick={() => copyToClipboard(id)} type="button">
                {id}
              </button>
            </Tooltip>

            {!!state.value && <Check className="size-4 text-blue-9" />}
          </>
        ) : (
          <div className="text-12 text-grey-9">
            Upgrade to Business or Enterprise to access API info.{' '}
            {canEditPlan ? (
              <button
                className="mr-1 inline text-grey-12 hover:underline"
                onClick={() =>
                  showContactSalesModal({
                    uiLocation: 'asset_modal_api_cta',
                  })
                }
                type="button"
              >
                Contact sales →
              </button>
            ) : (
              'Contact a workspace admin to upgrade.'
            )}
          </div>
        )}
      </div>
    </div>
  );
};
